export default __webpack_public_path__ + "static/media/world.f51b953e.png";